import { TransitionType } from '@src/slide/domain/ui-model/element-modeles/transition/constants';
import i18n from '@i18next/i18n';
import {
    COVER_RIGHT_ICON, CUT_NONE_ICON, FADE_SMOOTH_ICON, FLASH_ICON, FLIP_RIGHT_ICON, GALLERY_LEFT_ICON,
    NO_EFFECT_ICON, PRISM_RIGHT_ICON, PULL_RIGHT_ICON, PUSH_BOTTOM_ICON, SWITCH_LEFT_ICON, WARP_ENLARGE_ICON,
} from '@framework/workbench/ui/transition/transition-icon';

export interface ITransitionItem {
    type: TransitionType;
    text: string;
    icon: string;
    tooltip?: string;
}

export const emptyTransition: ITransitionItem = {
    type: TransitionType.EMPTY,
    text: i18n.t('无切换'),
    tooltip: i18n.t('无切换'),
    icon: NO_EFFECT_ICON,
};

export const fadeTransition: ITransitionItem = {
    type: TransitionType.FADE,
    text: i18n.t('淡出淡入'),
    tooltip: i18n.t('淡出淡入'),
    icon: FADE_SMOOTH_ICON,
};

export const pushTransition: ITransitionItem = {
    type: TransitionType.PUSH,
    text: i18n.t('推入'),
    tooltip: i18n.t('推入'),
    icon: PUSH_BOTTOM_ICON,
};

export const switchTransition: ITransitionItem = {
    type: TransitionType.SWITCH,
    text: i18n.t('切换'),
    tooltip: i18n.t('切换'),
    icon: SWITCH_LEFT_ICON,
};

export const cutTransition: ITransitionItem = {
    type: TransitionType.CUT,
    text: i18n.t('切入效果'),
    tooltip: i18n.t('切入效果'),
    icon: CUT_NONE_ICON,
};

export const pullTransition: ITransitionItem = {
    type: TransitionType.PULL,
    text: i18n.t('揭开'),
    tooltip: i18n.t('揭开'),
    icon: PULL_RIGHT_ICON,
};

export const coverTransition: ITransitionItem = {
    type: TransitionType.COVER,
    text: i18n.t('覆盖'),
    tooltip: i18n.t('覆盖'),
    icon: COVER_RIGHT_ICON,
};

export const warpTransition: ITransitionItem = {
    type: TransitionType.WARP,
    text: i18n.t('缩放'),
    tooltip: i18n.t('缩放'),
    icon: WARP_ENLARGE_ICON,
};

export const flipTransition: ITransitionItem = {
    type: TransitionType.FLIP,
    text: i18n.t('翻转'),
    tooltip: i18n.t('翻转'),
    icon: FLIP_RIGHT_ICON,
};

export const galleryTransition: ITransitionItem = {
    type: TransitionType.GALLERY,
    text: i18n.t('库'),
    tooltip: i18n.t('库'),
    icon: GALLERY_LEFT_ICON,
};

export const prismTransition: ITransitionItem = {
    type: TransitionType.PRISM,
    text: i18n.t('立方体'),
    tooltip: i18n.t('立方体'),
    icon: PRISM_RIGHT_ICON,
};

export const flashTransition: ITransitionItem = {
    type: TransitionType.FLASH,
    text: i18n.t('闪光'),
    tooltip: i18n.t('闪光'),
    icon: FLASH_ICON,
};

// todo 还有newsflash在选项中
